import { render, staticRenderFns } from "./JobGradeTable.vue?vue&type=template&id=5beed13c&"
import script from "./JobGradeTable.vue?vue&type=script&lang=js&"
export * from "./JobGradeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports